





































































































import { IWorkflowTransitionAction } from '@/models';

import { defineComponent, ref } from '@vue/composition-api';

import { useFetchActions } from '@/composable/useWorkflowTransitionAction';

import WorkflowTransitionActionDetailFormDialog from './WorkflowTransitionActionDetailFormDialog.vue';
import DeleteConfirmationDialog from '../common/DeleteConfirmationDialog.vue';
import WorkflowTransitionActionDetail from './WorkflowTransitionActionDetail.vue';

export const DRAWER_WIDTH = 550;

export default defineComponent({
  name: 'WorkflowTransitionActionsDrawerList',

  components: {
    DeleteConfirmationDialog,
    WorkflowTransitionActionDetailFormDialog,
    WorkflowTransitionActionDetail
  },

  props: {
    workflowId: {
      type: Number,
      required: true
    },

    transitionId: {
      type: Number,
      required: true
    },

    disabled: {
      type: Boolean
    }
  },

  setup(props) {
    const {
      actions: transitionActions,
      isLoadingActions,
      actionsError
    } = useFetchActions(props.workflowId, props.transitionId);

    const isEditingAction = ref(false);
    const isDialogActive = ref(false);

    const selectedAction = ref<IWorkflowTransitionAction | null>(null);

    function openTransitionActionDialog(action?: IWorkflowTransitionAction) {
      selectedAction.value = action ?? null;
      isEditingAction.value = !!action;
      isDialogActive.value = true;
    }

    return {
      isEditingAction,
      isDialogActive,
      selectedAction,

      openTransitionActionDialog,

      // Transition actions
      actionsError,
      transitionActions,
      transitionActionsLoading: isLoadingActions
    };
  }
});
